// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"52":"61044335","422":"8017f441","451":"7e8b83d7","558":"f527ea28","654":"c66585f1","671":"ff9b275a","837":"57a7cb7d"}[chunkId] + ".chunk.js";
};